import {
  CharlieBadge,
  type CharlieBadgeVariants,
} from '@ver.id/libs.ui.charlie';
import AppLogo from './AppLogo';

export type AppTileTag = {
  label: string;
  variant: CharlieBadgeVariants['variant'];
};

type Props = {
  name: string;
  logo?: string;
  /** A badge after the name, such as "Last used" or "Recommended". */
  tag?: AppTileTag;
  /** `compact` for the embedded card: a smaller logo, the same tile. */
  size?: 'default' | 'compact';
  onClick: () => void;
};

/** AppTile — One identity app to choose: its logo, its name and an optional tag. */
export default function AppTile({
  name,
  logo,
  tag,
  size = 'default',
  onClick,
}: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex w-full items-center gap-4 rounded-lg border border-border bg-card p-3 text-left transition-colors hover:bg-accent"
    >
      {/* The name already says which app; the logo is decoration. */}
      <span aria-hidden="true" className="flex shrink-0">
        <AppLogo
          src={logo}
          name={name}
          className={size === 'compact' ? 'size-8 rounded-lg' : undefined}
        />
      </span>
      <span className="min-w-0 flex-1 truncate text-sm font-semibold text-foreground">
        {name}
      </span>
      {/* Keeps the name and the tag apart in the button's accessible name. */}
      {tag && ' '}
      {tag && <CharlieBadge variant={tag.variant}>{tag.label}</CharlieBadge>}
    </button>
  );
}
